export default __webpack_public_path__ + "img/f8c6e4363efd26532a841d11585fd5c6.png";